import { cn } from '@module/lib/utils';
import useChatPanelStore from '@module/stores/useChatPanelStore';

interface Props {
  text: string | undefined;
}

function IntroChat({ text }: Props) {
  const pcFontSize = useChatPanelStore((state) => state.pcFontSize);

  const fontSizeClass = {
    'text-[13px]': pcFontSize === 13,
    'text-[15px]': pcFontSize === 15,
    'text-[19px]': pcFontSize === 19,
  };
  if (!text || text.trim() === '') return null;
  return (
    <div className={cn('mb-[3px]', fontSizeClass)}>
      <span className='whitespace-pre-wrap text-cht_al_co'>{text}</span>
    </div>
  );
}

export default IntroChat;
